import { Component, Input } from '@angular/core';
import { Itinerary } from '@generated/graphql';
import { TripsItineraryExclusionItemComponent } from '../components/trips-itinerary-exclusion-item/trips-itinerary-exclusion-item.component';
import { TripsItineraryInclusionItemComponent } from '../components/trips-itinerary-inclusion-item/trips-itinerary-inclusion-item.component';

@Component({
    selector: 'app-trips-inclusions-exclusions-section',
    imports: [
        TripsItineraryInclusionItemComponent,
        TripsItineraryExclusionItemComponent,
    ],
    templateUrl: './trips-inclusions-exclusions-section.component.html',
    styles: [],
})
export class TripsInclusionsExclusionsSectionComponent {
    @Input() itinerary: Itinerary;
    readonly defaultNoOfExclusionsDisplayed = 6;
    readonly defaultNoOfInclusionsDisplayed = 6;

    noOfExclusionsDisplayed = this.defaultNoOfExclusionsDisplayed;
    noOfInclusionsDisplayed = this.defaultNoOfInclusionsDisplayed;

    toggleInclusionsDisplayed = (inclusions: string[]) => {
        if (
            this.noOfInclusionsDisplayed === this.defaultNoOfInclusionsDisplayed
        ) {
            this.noOfInclusionsDisplayed = inclusions.length;
        } else {
            this.noOfInclusionsDisplayed = this.defaultNoOfInclusionsDisplayed;
        }
    };

    toggleExclusionsDisplayed = (exclusions: string[]) => {
        if (
            this.noOfExclusionsDisplayed === this.defaultNoOfExclusionsDisplayed
        ) {
            this.noOfExclusionsDisplayed = exclusions.length;
        } else {
            this.noOfExclusionsDisplayed = this.defaultNoOfExclusionsDisplayed;
        }
    };
}
